import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const HowItWorksSection: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-[rgba(54,54,58,0.3)]">
            <div className="relative flex flex-col items-center mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px] py-[100px] dmax2:py-[60px]">
                <h1 className="H32B dmax2:H20B text-textWhite text-center w-full mb-10 dmax2:mb-6">
                    {t("main.needHelp")}
                </h1>
                <div className="flex flex-col">
                    <div className="flex items-center mb-8 dmax2:mb-4">
                        <div className="H32B dmax2:H20B text-textWhite flex justify-center items-center w-[60px] dmax2:w-[44px] h-[60px] dmax2:h-[44px] bg-textWarning rounded-[100px] mr-6 dmax2:mr-3">
                            1
                        </div>
                        <span className="H20B dmax2:H16 text-textWhite dmax2:w-[296px]">{t("main.helpStep1")}</span>
                    </div>
                    <div className="flex items-center mb-8 dmax2:mb-4">
                        <div className="H32B dmax2:H20B text-textWhite flex justify-center items-center w-[60px] dmax2:w-[44px] h-[60px] dmax2:h-[44px] bg-textWarning rounded-[100px] mr-6 dmax2:mr-3">
                            2
                        </div>
                        <span className="H20B dmax2:H16 text-textWhite dmax2:w-[296px]">{t("main.helpStep2")}</span>
                    </div>
                    <div className="flex items-center mb-8 dmax2:mb-4">
                        <div className="H32B dmax2:H20B text-textWhite flex justify-center items-center w-[60px] dmax2:w-[44px] h-[60px] dmax2:h-[44px] bg-textWarning rounded-[100px] mr-6 dmax2:mr-3">
                            3
                        </div>
                        <span className="H20B dmax2:H16 text-textWhite dmax2:w-[296px]">{t("main.helpStep3")}</span>
                    </div>
                    <div className="flex items-center">
                        <div className="H32B dmax2:H20B text-textWhite flex justify-center items-center w-[60px] dmax2:w-[44px] h-[60px] dmax2:h-[44px] bg-textWarning rounded-[100px] mr-6 dmax2:mr-3">
                            4
                        </div>
                        <span className="H20B dmax2:H16 text-textWhite dmax2:w-[296px]">{t("main.helpStep4")}</span>
                    </div>
                </div>
                <div className="relative mt-10 dmax2:mt-6">
                    <Link
                        to="/create-work"
                        className="button H16B dmax2:H14B text-textWhite h-[50px] dmax2:h-10 px-6 dmax2:px-4 transition duration-300"
                    >
                        {t("main.helpButton")}
                    </Link>
                    <div className="absolute top-[-10px] dmax2:top-[0px] right-[-50px] dmax2:right-[-60px] flex justify-center items-center H12 text-textWhite bg-accentGreen rounded-[30px] rotate-[23deg] dmax2:rotate-[30deg] h-7 dmax2:h-[26px] px-4 dmax2:px-3">
                        {t("main.helpLabel")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowItWorksSection;
